import { Type } from "class-transformer";
import { minutesToTimeFormat } from "../utils/dateUtils";
import { AbstractJSONModel } from "./master-model";
export interface ISupervisionTimeDuties {
  id: number | null;
  created_at: Date;
  updated_at: Date;
  supervision_time_schedule_id: number;
  employee_id: number;
  day_of_week: number;
  start_time: number | null;
  end_time: number | null;
  department_id: number | null;
}

export interface ISupervisionTimeDutiesPut {
  id: number | null;
  supervision_time_schedule_id: number;
  employee_id: number;
  day_of_week: number;
  start_time: number | null;
  end_time: number | null;
  week_cycle_index: number;
  department_id: number | null;
}

export class SupervisionTimeDuties extends AbstractJSONModel implements ISupervisionTimeDuties {
  public id: number | null = null;
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date = new Date();
  public supervision_time_schedule_id = -1;
  public employee_id = -1;
  public day_of_week = -1;
  public start_time: number | null = null;
  public end_time: number | null = null;
  public week_cycle_index = 1;
  public department_id: number | null = null;
  // Only front-end
  public index = -1;

  public get from(): string | null {
    if (this.start_time || this.start_time === 0) {
      return minutesToTimeFormat(this.start_time);
    } else {
      return null;
    }
  }

  public get to(): string | null {
    if (this.end_time || this.end_time === 0) {
      return minutesToTimeFormat(this.end_time);
    } else {
      return null;
    }
  }

  public convertToPutObject(): ISupervisionTimeDutiesPut {
    const s: ISupervisionTimeDutiesPut = Object.assign({});
    s.day_of_week = this.day_of_week;
    s.employee_id = this.employee_id;
    s.end_time = this.end_time;
    s.id = this.id;
    s.start_time = this.start_time;
    s.supervision_time_schedule_id = this.supervision_time_schedule_id;
    s.week_cycle_index = this.week_cycle_index;
    s.department_id = this.department_id;
    return s;
  }

  equals(other: ISupervisionTimeDuties): boolean {
    return other.id === this.id;
  }
}
